

<div mat-dialog-title style="position: relative;">
    <p style="font-weight: bold; background-color: #efefef; color: #c89d07;padding: 8px;margin-top: -8px;
    margin-left: -24px;margin-right: -24px;">
        Update {{data?.firstName}} {{data?.lastName}}({{data?.profileID}}) customer details
    </p>
    <button type="button" class="close" data-dismiss="modal" aria-label="Close"
       (click)="onNoClick()" style="color: black; top: 0px;left: 800px;position: absolute;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
</div>

<div mat-dialog-content class="dialog-content">
    <form class="row" [formGroup]="customerUpdateForm">
        <div class="col-md-4 flexRows">
            <div class="inputBox customMultiSelect">
                <p class="text-left">Arrival Date</p>
                <input matInput [matDatepicker]="arrival" class="form-control ka-disabled" placeholder="Arrival Date"
                  formControlName="arrivalDate">
                <mat-datepicker-toggle matSuffix [for]="arrival"
                  style="position: absolute;margin-left: 75%;margin-top: -50px;" [disabled]="disableDate"></mat-datepicker-toggle>
                <mat-datepicker #arrival [disabled]="disableDate"></mat-datepicker>
                <div *ngIf="customerUpdateForm.controls['arrivalDate'].errors && !customerUpdateForm.controls['arrivalDate'].pristine "
                    class="error-msg1">
                    <div>Arrival Date required.</div>
                </div>
            </div>
        </div>
        <div class="col-md-4 flexRows">
            <div class="inputBox customMultiSelect">
                <p class="text-left">Departure Date</p>
                <input matInput [matDatepicker]="departure" class="form-control ka-disabled" placeholder="Departure Date"
                  formControlName="departureDate">
                <mat-datepicker-toggle matSuffix [for]="departure"
                  style="position: absolute;margin-left: 75%;margin-top: -50px;" [disabled]="disableDate"></mat-datepicker-toggle>
                <mat-datepicker #departure [disabled]="disableDate"></mat-datepicker>
                <div *ngIf="customerUpdateForm.controls['departureDate'].errors && !customerUpdateForm.controls['departureDate'].pristine "
                    class="error-msg1">
                    <div>Departure Date is required.</div>
                </div>
              </div>
        </div>
        <div class="col-md-4 flexRows">
            <div class="inputBox customMultiSelect" style="margin-top: 15%;">
                <mat-checkbox (change)="onChange($event)" formControlName="isLeftIndia">Left India?</mat-checkbox>
            </div>
        </div>
        <div class="col-md-6">
            <div class="inputBox customMultiSelect">
                <p class="text-left">Description</p>
                <textarea formControlName="description" id="" cols="40" rows="5"></textarea>
                <div *ngIf="customerUpdateForm.controls['description'].errors && !customerUpdateForm.controls['description'].pristine "
                    class="error-msg1">
                    <div>Description is required.</div>
                </div>
            </div>
        </div>
    </form>
</div>
<div mat-dialog-actions align="end">
    <div>
        <button mat-raised-button (click)="onNoClick()">Cancel</button>
        <button mat-raised-button [disabled]="!customerUpdateForm.valid" (click)="onSubmit()" class="submit">Submit</button>
    </div>
</div>